import React from 'react';

import { buttons, colors, typography } from '@pray/shared/components/foundations';
import Button from '@pray/shared/components/ui/Button/Button';
import StickyButton from '@pray/shared/components/ui/StickyButton/StickyButton';
import Text from '@pray/shared/components/ui/Text/Text';
import Container from '@pray/shared/components/v1/Container/Container';
import flowStyles from '@pray/shared/components/v1/FlowStyles.module.css';
import { EVENTS } from '@pray/shared/constants';

import type { EmailConfirmationPageProps } from './types';

import pageStyles from './EmailConfirmationPage.module.css';

const styles = {
  ...flowStyles,
  ...pageStyles,
};

export default function EmailConfirmationPage({
  data,
  title = 'Great! Now, check your email!',
  subtitle = 'To confirm your email address',
  customStyles = {},
  handleEmailValidation,
}: EmailConfirmationPageProps) {
  const handleResendLink = async () => {
    await handleEmailValidation();
  };

  return (
    <>
      <Container
        align="left"
        className={pageStyles.container}
        data-viewname={EVENTS.PRAY_EVENTS.VIEW_EVENT_NAMES.LANDER_REDEEM_FLOW.EMAIL_CONFIRMATION}
      >
        <div className={styles.viewport}>
          <div className={styles.desktop}>
            <Text variant={typography.h1}>{title}</Text>
          </div>
          <div>
            <Text variant={typography.headline_small} color={colors.text_secondary}>
              {subtitle}, <span className="mobile-only">tap</span>
              <span className="desktop-only">click</span> the button in the email we sent to{' '}
              <Text color={colors.text_featured}>{data.email}</Text>
            </Text>
          </div>
        </div>
      </Container>
      <StickyButton
        customStyles={customStyles.buttons}
        data-viewname={EVENTS.PRAY_EVENTS.VIEW_EVENT_NAMES.LANDER_REDEEM_FLOW.EMAIL_CONFIRMATION}
      >
        <Text variant={typography.body} color={colors.text_secondary}>
          Didn’t receive the email?
        </Text>
        <Button
          full
          variant={buttons.variant.secondary}
          className={pageStyles.resendTextAction}
          onClick={handleResendLink}
        >
          Resend link
        </Button>
      </StickyButton>
    </>
  );
}
